/*
 *
 * ProductPriceCustomer constants
 *
 */

export const DEFAULT_ACTION = 'app/ProductPriceCustomer/DEFAULT_ACTION';
